// Modelo Dinamico para monitoreo.

//TIPO 0: Solo LABEL
//{valor:"", descripcion:"", tipo:0 ,label:"g. Exposiciones en trabajos anteriores (ver HCU):",label2:"Tipo Detalle"},

//TIPO 1: select con opciones
//{valor:"", descripcion:"", tipo:1 ,label:"a. Datos de filiación:" ,data:["SI","NO"]},

//TIPO 2: Select con opciones y un campo con descripcion
//{valor:"", descripcion:"", valor2:"", tipo:2 ,label:"Discoteca:",data:["SI","NO"],label2:"veces/mes"},

//TIPO 3: Campo para observaciones inputText
//{valor:"", descripcion:"", tipo:3 ,label:"Valor:"},

//TIPO 4: Campo para observaciones textArea
//{valor:"", descripcion:"", tipo:4 ,label:"Valor:"},

export default class MonitoreoRespiratorioAnsiedadDepresion {
    fecha={}
    lista=[
        {
            encabezado:"Datos de filiación",
            datos:[
                {valor:"", descripcion:"", tipo:21 ,label:"      C.I.: 1721930442", bold:false},
                {valor:"", descripcion:"", tipo:22 ,label:"      Edad: 32", bold:false},
                {valor:"", descripcion:"", tipo:23 ,label:"      Apellidos y nombres: LOPEZ CRISTIAN", bold:false},
                {valor:"", descripcion:"", tipo:24 ,label:"      Empresa: PRIVADOS", bold:false},
                {valor:"", descripcion:"", tipo:25 ,label:"      Puesto de trabajo: PRIVADO", bold:false},
            ]
        },
        {
            encabezado:"CONDUCTAS y ALTERNATIVAS",
            datos:[
                {valor:"", descripcion:"", tipo:1 ,label:"1. ¿Ha podido concentrarse bien en lo que hace?" ,data:["Mejor que lo habitual","Igual que lo habitual","Menos que lo habitual","Mucho menos que lo habitual"]},
                {valor:"", descripcion:"", tipo:1 ,label:"2. ¿Sus preocupaciones le han hecho perder mucho el sueño?" ,data:["No, en absoluto","Igual que lo habitual","Más que lo habitual","Mucho más que lo habitual"]},
                {valor:"", descripcion:"", tipo:1 ,label:"3. ¿Ha sentido que está desempeñando un papel útil en su vida?:" ,data:["Más que lo habitual","Igual que lo habitual","Menos que lo habitual","Mucho menos que lo habitual"]},
                {valor:"", descripcion:"", tipo:1 ,label:"4. ¿Se ha sentido capaz de tomar decisiones?:" ,data:["Más capaz que lo habitual","Igual que lo habitual","Menos capaz que lo habitual","Mucho menos capaz que lo habitual"]},
                {valor:"", descripcion:"", tipo:1 ,label:"5. ¿Se ha sentido constantemente agobiado y en tensión?" ,data:["No, en absoluto","Igual que lo habitual","Más que lo habitual","Mucho más que lo habitual"]},
                {valor:"", descripcion:"", tipo:1 ,label:"6. ¿Ha sentido que no puede superar sus dificultades?" ,data:["No, en absoluto","Igual que lo habitual","Más que lo habitual","Mucho más que lo habitual"]},
                {valor:"", descripcion:"", tipo:1 ,label:"7. ¿Ha sido capaz de disfrutar sus actividades normales de cada día?" ,data:["Más que lo habitual","Igual que lo habitual","Menos que lo habitual","Mucho menos que lo habitual"]},
                {valor:"", descripcion:"", tipo:1 ,label:"8. ¿Ha sido capaz de hacer frente adecuadamente a sus problemas?" ,data:["Más capaz que lo habitual","Igual que lo habitual","Menos capaz que lo habitual","Mucho menos capaz que lo habitual"]},
                {valor:"", descripcion:"", tipo:1 ,label:"9. ¿Se ha sentido poco feliz o deprimido/a?" ,data:["No, en absoluto","No más que lo habitual","Más que lo habitual","Mucho más que lo habitual"]},
                {valor:"", descripcion:"", tipo:1 ,label:"10. ¿Ha perdido confianza en sí mismo?" ,data:["No, en absoluto","No más que lo habitual","Más que lo habitual","Mucho más que lo habitual"]},
                {valor:"", descripcion:"", tipo:1 ,label:"11. ¿Ha pensado que usted es una persona que no vale para nada?" ,data:["No, en absoluto","No más que lo habitual","Más que lo habitual","Mucho más que lo habitual"]},
                {valor:"", descripcion:"", tipo:1 ,label:"12. ¿Se siente razonablemente feliz considerando todas las circunstancias?" ,data:["Más feliz que lo habitual","Igual que lo habitual","Menos feliz que lo habitual","Mucho menos feliz que lo habitual"]},
                {valor:"", descripcion:"", tipo:5 ,label:"CALCULAR", click:2 },
                {valor:"", descripcion:"", tipo:3 ,label:"PUNTAJE" },
            ]
        },
    ]
}
var today = new Date();
var dd = today.getDate();
var mm = today.getMonth() + 1; //January is 0!

var yyyy = today.getFullYear();
if (dd < 10) {
    dd = '0' + dd;
}
if (mm < 10) {
    mm = '0' + mm;
}
var today = dd + '/' + mm + '/' + yyyy;





// WEBPACK FOOTER //
// ./src/model/MonitoreoSaludMentalAnsiedadDepresion.js